export enum OrderDirection {
  Ascending = "Ascending",
  Descending = "Descending"
}
